import api from './api';
import type { MenuSection } from '../types/menu';

const base = (venueId: string, menuId: string) =>
  `/admin/venue/${venueId}/menu/${menuId}/sections`;

const menuSectionService = {
  /** List active sections on a menu, ordered by position then name. */
  getSections: async (venueId: string, menuId: string): Promise<MenuSection[]> => {
    const response = await api.get(base(venueId, menuId));
    return response.data;
  },

  /** Get a single section. */
  getSection: async (venueId: string, menuId: string, sectionId: string): Promise<MenuSection> => {
    const response = await api.get(`${base(venueId, menuId)}/${sectionId}`);
    return response.data;
  },

  /** Create a section. */
  createSection: async (
    venueId: string,
    menuId: string,
    data: Pick<MenuSection, 'name'> &
      Partial<Pick<MenuSection, 'description' | 'position' | 'visibility'>>,
  ): Promise<MenuSection> => {
    const response = await api.post(base(venueId, menuId), data);
    return response.data;
  },

  /** Partial update of a section. */
  updateSection: async (
    venueId: string,
    menuId: string,
    sectionId: string,
    data: Partial<Pick<MenuSection, 'name' | 'description' | 'position' | 'visibility' | 'active'>>,
  ): Promise<MenuSection> => {
    const response = await api.patch(`${base(venueId, menuId)}/${sectionId}`, data);
    return response.data;
  },

  /** Soft-delete a section (active=false). Items pointing at the section are
   *  reparented to sectionId=null on the backend. */
  deleteSection: async (venueId: string, menuId: string, sectionId: string): Promise<void> => {
    await api.delete(`${base(venueId, menuId)}/${sectionId}`);
  },
};

export default menuSectionService;
